import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  spenttypes,
  spenttypesForm,
  accounts,
  accountsForm,
  spents,
  spentsForm,
  deposits,
  depositsForm,
} from "./Reducers";

export default combineReducers({
  deposits,
  depositsForm,
  spents,
  spentsForm,
  accounts,
  accountsForm,
  spenttypes,
  spenttypesForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
